import type { CommercialOperation } from '@/modules/commercial/types';
import type { InvoiceInput } from '@/modules/billing/types';

export function buildInvoiceInputFromOperation(
  operation: CommercialOperation,
): InvoiceInput {
  const today = new Date().toISOString().slice(0, 10);
  return {
    commercialOperationId: operation.id,
    clientId: operation.clientId,
    type: 'internal',
    status: 'draft',
    issueDate: today,
    dueDate: '',
    subtotal: operation.subtotal,
    taxes: operation.taxAmount,
    total: operation.total > 0 ? operation.total : operation.subtotal + operation.taxAmount,
    currency: 'ARS',
    notes: operation.notes ? `Operación: ${operation.title}` : '',
  };
}
